import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { TextField, Box, Typography } from "@mui/material";
import { Editor } from "primereact/editor";
import Button from "@mui/material/Button";
import TopHeader from "../../Component/Header/TopHeader";
import "../../style/css/journalForm.css";
import { useFieldArray, useForm } from "react-hook-form";
import { FormControlLabel, Checkbox } from "@mui/material";
import {
  useSaveSIGGroupMutation,
  useUpdateSIGGroupMutation,
  useLazyGetSIGGroupByIdQuery,
} from "../../app/services/SIGGroupServices";
import "../../style/css/SIGGroupTable.css";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import Spinner from "../../Component/spinner/spinner";
import { selectCurrentScope, selectUserId } from "../../app/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLazyGetAllSIGQuery } from "../../app/services/SIGServices";
import { setAllSig } from "../../app/features/sigSlice";
import ImageCropModal from "../../Component/ImageCropModal/ImageCropModal";
import userLogo from "../../assets/images/login/userLogo.jpg";

const SIGGroupForm = () => {
  const navigate = useNavigate()
  const [data, setData] = useState([]);
  const [saveSIGGroup] = useSaveSIGGroupMutation();
  const [updateSIGGroup] = useUpdateSIGGroupMutation();
  const [getAllSig] = useLazyGetAllSIGQuery();
  const { sigGroupId } = useParams();
  const [loading, setLoading] = useState(false);
  const [initialData, setInitalData] = useState([]);
  const memberScope = useSelector(selectCurrentScope);
  const userId = useSelector(selectUserId);
  const [isAdmin, setIsAdmin] = useState('')
  const [descriptionText, setDescriptionText] = useState("");
  const [selectedRoleImage, setSelectedRoleImage] = useState([]);
  const [cropModal, setCropModal] = useState({ open: false, index: null, src: null });
  const dispatch = useDispatch();

  const {
    control,
    register,
    handleSubmit,
    watch,
    trigger,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      groupName: "",
      description: "",
      removedAdminEmail: [],
      removedUserId: [],
      adminsId: [],
      roleDetails: [],
      createdBy: {
        id: "",
        role: "",
      },//required
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "roleDetails",
  });

  // Adding a new empty object to roleDetails array when "Add Office Bearers" button is clicked
  const addRoleDetails = () => {
    append({
      name: "",
      address: "",
      mobile: "",
      email: "",
      role: "",
      isAdmin: false,
      password: "",
      imageUrl: "",
    });
  };

  // Removing Roledetails for each row except the first one
  const removeRoleDetails = (index) => {
    remove(index);
  };


  //remove admin
  // const removeAdmin = (member, index) => {
  //   const data = {
  //     sigGroupId,
  //     roleId: member._id,
  //     userId: member.userId,
  //   }
  //   setLoading(true);
  //   // removeMemberAdmin(data).then(res => {
  //   //   if (res.data?.data) {
  //   //     setLoading(false);
  //   //     toast.success(res.data?.message)
  //   //     remove(index)
  //   //     getSigGroupById(sigGroupId);
  //   //   }
  //   //   else {
  //   //     setLoading(false);
  //   //     toast.error(res.data?.message)
  //   //     getSigGroupById(sigGroupId);
  //   //   }
  //   // })
  // }

  const [getSigGroupById] = useLazyGetSIGGroupByIdQuery(sigGroupId);

  //getSigGroupById
  useEffect(() => {
    if (sigGroupId) {
      setLoading(true);
      getSigGroupById(sigGroupId).then((res) => {
        if (res.data.status) {
          setLoading(false);
          const sigData = res.data?.data;
          if (sigData) {
            setInitalData(res.data?.data);
            setValue("groupName", sigData.groupName);
            setValue("description", sigData.description);
            setDescriptionText(sigData.description || "");
            if (sigData.roleDetails.length !== 0) {
              setValue("roleDetails", sigData.roleDetails);
              const roleImages = sigData.roleDetails.map((item) => item.imageUrl || "");
              setSelectedRoleImage(roleImages);
            }
          }
        }
      });
    }
  }, [sigGroupId, getSigGroupById, setValue]);

  // Open crop modal when user selects an image
  const handleRoleImageFileChange = (event, index) => {
    const file = event.target.files[0];
    // Reset input so the same file can be re-selected after cancel
    event.target.value = "";
    if (!file || !file.type.startsWith("image/")) {
      toast.error("Please select an image file.");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image size must be under 5MB.");
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      setCropModal({ open: true, index, src: e.target.result });
    };
    reader.readAsDataURL(file);
  };

  // Called when user clicks "Apply Crop" inside the modal
  const handleCropApply = (base64) => {
    const { index } = cropModal;
    // Resize to 140×140 for storage
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = 140;
      canvas.height = 140;
      const ctx = canvas.getContext("2d");

      // 1. Draw solid white background
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, 140, 140);

      // 2. Draw the cropped logo on top of it
      ctx.drawImage(img, 0, 0, 140, 140);

      const finalBase64 = canvas.toDataURL("image/png");
      setSelectedRoleImage((prev) => { const n = [...prev]; n[index] = finalBase64; return n; });
      setValue(`roleDetails.${index}.imageUrl`, finalBase64);
      setCropModal({ open: false, index: null, src: null });
    };
  };

  //saveSig Group
  const onSaveSIGGroup = (formData) => {
    formData.description = descriptionText;
    if (!descriptionText || !descriptionText.replace(/<[^>]*>/g, '').trim()) {
      toast.error("Please enter a description");
      return;
    }
    const isDuplicateEmail = formData?.roleDetails.some(
      (detail, index, self) =>
        self.findIndex((t) => t.email === detail.email) !== index
    );
    if (isDuplicateEmail) {
      toast.error("Please enter unique emails");
      return;
    }
    setLoading(true);
    trigger().then((isValid) => {
      if (isValid) {
        setData([...data, formData
        ]);
        formData.createdBy = {
          id: userId,
          role: memberScope,
        };
        const base64Regex = /^data:image\/(?:png|jpeg|jpg|gif);base64,[\w+/=]+$/;
        if (sigGroupId) {
          const formRoleDetailsIds = formData.roleDetails.map(
            (role) => role._id
          );
          const filteredData = initialData?.roleDetails?.filter((item) => {
            const isIncluded = formRoleDetailsIds.includes(item._id);
            return !isIncluded;
          });
          const isAdminStatus = filteredData.filter(
            (item) => item.isAdmin === true
          );
          const email = filteredData.map((item) => item.email);
          setValue("removedAdminEmail", email);
          formData.removedAdminEmail = watch("removedAdminEmail");
          if (isAdminStatus) {
            const userID = isAdminStatus.map((id) => id.userId);
            setValue("adminsId", initialData.adminsId);
            setValue("removedUserId", userID);
            formData.adminsId = watch("adminsId");
            formData.removedUserId = watch("removedUserId");
            // Normalize imageUrl: keep base64 or strip to relative path
            formData.roleDetails = formData.roleDetails.map((item) => ({
              ...item,
              imageUrl: base64Regex.test(item.imageUrl)
                ? item.imageUrl
                : item.imageUrl?.split("/").slice(-3).join("/") || "",
            }));
            let requestIdAndData = { id: sigGroupId, data: formData };
            updateSIGGroup(requestIdAndData).then((res) => {
              if (res.data?.status) {
                setLoading(false);
                toast.success(res.data?.message);
                navigate("/addEditSigGroups");
                getAllSig().then(res => {
                  dispatch(setAllSig(res?.data?.data))
                })
              } else {
                setLoading(false);
                toast.error(res.data?.err?.message);
              }
            });
          }
        } else {

          saveSIGGroup(formData).then((res) => {
            if (res.data?.status) {
              setLoading(false);
              toast.success(res.data?.message);
              navigate("/addEditSigGroups");
              getAllSig().then(res => {
                dispatch(setAllSig(res?.data?.data))
              })
            } else {
              setLoading(false);
              toast.error(res.data?.err?.message);
            }
          });
        }
      }
    });
  };

  return (
    <>
      <TopHeader />
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">{sigGroupId ? "Edit SIG" : "Add SIG"}</h2>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <Box
          className="d-flex flex-column p-md-5 p-3 overallPadding ">
          <div className="text-end w-100">
            <Button
              onClick={() => window.history.back()}
              variant="contained"
              className="menus-color"
              style={{ float: "right" }}>
              Back
            </Button>
          </div>
          <div style={{ marginTop: "25px", marginBottom: "50px" }}>
            <form onSubmit={handleSubmit(onSaveSIGGroup)}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  marginBottom: "20px",
                }}
              >
                <TextField
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "100%" }}
                  id="groupName"
                  label={
                    <Typography className="text-dark">
                      Group Name <span style={{ color: "red" }}>*</span>
                    </Typography>
                  }
                  variant="outlined"
                  error={!!errors.groupName}
                  helperText={errors.groupName?.message}
                  {...register("groupName", {
                    required: "Please enter a group name",
                    minLength: {
                      value: 3,
                      message: '"Group name must be minimum 3 characters"'
                    },
                    maxLength: {
                      value: 150,
                      message: '"Group name must be maximum 150 characters"'
                    },
                  })}
                  placeholder="Enter group name"
                />
                <div style={{ width: "100%" }}>
                  <Typography className="text-dark" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Description <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Editor
                    value={descriptionText}
                    onTextChange={(e) => setDescriptionText(e.htmlValue || "")}
                    style={{ height: "200px" }}
                    placeholder="Enter description"
                  />
                </div>
              </div>
              <div style={{ width: "49%", marginBottom: "20px" }}>
                <Button
                  variant="contained"
                  className="menus-color"
                  onClick={addRoleDetails}
                >
                  Add Office Bearers
                </Button>
              </div>
              {fields.map((details, index) => (
                <div key={details.id}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "20px",
                    }}
                  >
                    <TextField
                      style={{ width: "49%" }}
                      InputLabelProps={{ shrink: true }}
                      label={
                        <Typography className="text-dark">
                          Name <span style={{ color: "red" }}>*</span>
                        </Typography>
                      }
                      {...register(`roleDetails.${index}.name`, {
                        required: "Please enter a name",
                        minLength: {
                          value: 3,
                          message: "Name must be min length of 3",
                        },
                      })}
                      error={!!errors?.roleDetails?.[index]?.name}
                      helperText={errors?.roleDetails?.[index]?.name?.message}
                      placeholder="Enter name"

                    />
                    <TextField
                      style={{ width: "49%" }}
                      InputLabelProps={{ shrink: true }}
                      label={
                        <Typography className="text-dark">
                          Email <span style={{ color: "red" }}>*</span>
                        </Typography>
                      }
                      {...register(`roleDetails.${index}.email`, {
                        required: "Please enter a email ID",
                        pattern: {
                          value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                          message: "Please enter valid email",
                        },
                        validate: (value) => {
                          const roles = getValues('roleDetails')
                          const sameMailRoles = roles.filter(item => item.email === value)
                          if (sameMailRoles.length > 1) {
                            return 'Email ID Already Exists !!!'
                          }
                        }, onChange: () => {
                          setValue(`roleDetails.${index}.isAdmin`, false)
                          trigger('roleDetails')
                        }
                      })}
                      error={!!errors?.roleDetails?.[index]?.email}
                      helperText={errors?.roleDetails?.[index]?.email?.message}
                      placeholder="Enter email"

                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "20px",
                    }}
                  >
                    <TextField
                      style={{ width: "49%" }}
                      InputLabelProps={{ shrink: true }}
                      label={
                        <Typography className="text-dark">
                          Mobile
                        </Typography>
                      }
                      {...register(`roleDetails.${index}.mobile`, {
                        //   required: "Please enter a mobile number",
                        validate: (value) => {
                          if (value === undefined || value === null || String(value).trim() === "") {
                            return true; // optional field, empty is fine
                          }

                          if (String(value).length !== 10) {
                            return "Please enter a valid 10-digit phone number";
                          }
                          // Additional validation logic if needed
                          return true; // Validation passed
                        },
                      })}
                      error={!!errors?.roleDetails?.[index]?.mobile}
                      helperText={errors?.roleDetails?.[index]?.mobile?.message}
                      placeholder="Enter mobile number"

                    />
                    <TextField
                      style={{ width: "49%" }}
                      InputLabelProps={{ shrink: true }}
                      label={
                        <Typography className="text-dark">
                          Role <span style={{ color: "red" }}>*</span>
                        </Typography>
                      }
                      {...register(`roleDetails.${index}.role`, {
                        required: "Role is required",
                      })}
                      error={!!errors?.roleDetails?.[index]?.role}
                      helperText={errors?.roleDetails?.[index]?.role?.message}
                      placeholder="Enter role"

                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "20px",
                    }}
                  >
                    <TextField
                      style={{ width: "49%" }}
                      InputLabelProps={{ shrink: true }}
                      label={
                        <Typography className="text-dark">
                          Address
                        </Typography>
                      }
                      {...register(`roleDetails.${index}.address`, {
                        //   required: "Please enter a address",
                      })}
                      // error={!!errors?.roleDetails?.[index]?.address}
                      // helperText={errors?.roleDetails?.[index]?.address?.message}
                      placeholder="Enter address"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "20px",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {/* Profile Image Upload with interactive 1:1 crop (Facebook/WhatsApp style) */}
                    <div style={{ width: "49%" }}>
                      <Typography className="text-dark" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                        Profile Photo
                      </Typography>
                      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                        <div
                          style={{
                            width: 90,
                            height: 90,
                            borderRadius: "50%",
                            overflow: "hidden",
                            border: "2px solid #ccc",
                            flexShrink: 0,
                            background: "#f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {(selectedRoleImage[index] || watch(`roleDetails.${index}.imageUrl`)) ? (
                            <img
                              src={
                                selectedRoleImage[index]
                                  ? (selectedRoleImage[index].startsWith("data:image/")
                                    ? selectedRoleImage[index]
                                    : `${selectedRoleImage[index]}?t=${new Date().getTime()}`)
                                  : watch(`roleDetails.${index}.imageUrl`)
                              }
                              alt="Profile"
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          ) : (
                            <span style={{ fontSize: 32, color: "#aaa" }}><img src={userLogo} alt="Profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></span>
                          )}
                        </div>
                        <div>
                          <Button
                            variant="outlined"
                            component="label"
                            size="small"
                            className="menus-color"
                            style={{ color: "white", whiteSpace: "nowrap" }}
                          >
                            {(selectedRoleImage[index] || watch(`roleDetails.${index}.imageUrl`)) ? "Change Photo" : "Upload Photo"}
                            <input
                              type="file"
                              accept="image/*"
                              hidden
                              onChange={(e) => handleRoleImageFileChange(e, index)}
                            />
                          </Button>
                          <Typography variant="caption" display="block" style={{ marginTop: 4, color: "#888" }}>
                            Crop to 1:1 ratio (drag &amp; zoom to adjust).
                          </Typography>
                          {(selectedRoleImage[index] || watch(`roleDetails.${index}.imageUrl`)) && (
                            <Button
                              size="small"
                              variant="text"
                              color="error"
                              style={{ marginTop: 2, padding: 0, minWidth: 0 }}
                              onClick={() => {
                                setSelectedRoleImage((prev) => { const n = [...prev]; n[index] = null; return n; });
                                setValue(`roleDetails.${index}.imageUrl`, "");
                              }}
                            >
                              Remove
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* Admin checkbox */}
                    <div style={{ width: "49%", display: "flex", alignItems: "center", paddingTop: "28px" }}>
                      {!sigGroupId && (isAdmin === index || (watch('roleDetails') && watch('roleDetails').every(item => !item.isAdmin))) && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              style={{ color: sigGroupId ? "grey" : "#1976d2" }}
                              checked={watch(`roleDetails.${index}.isAdmin`)}
                              {...register(`roleDetails.${index}.isAdmin`, {
                                onChange: (e) => {
                                  if (e.target.value) {
                                    setIsAdmin(index)
                                  }
                                }
                              })}
                            />
                          }
                          label={
                            <Typography className="text-dark">Admin</Typography>
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div>
                    {(((!watch(`roleDetails.${index}.isAdmin`) && sigGroupId) || memberScope === 'PORTAL_SUPER_ADMIN') || !sigGroupId) && <div style={{ marginBottom: "50px" }}>
                      <div className="float-end">
                        <Button className="border-radius-membership-wallpage-button"
                          variant="contained"
                          style={{ background: "red" }}
                          onClick={() => removeRoleDetails(index)}
                        >
                          <DeleteIcon />
                          Remove
                        </Button>
                      </div>
                      <br />
                    </div>}
                  </div>
                </div>
              ))}
              <div className="text-center mt-5">
                <Button variant="contained" className="menus-color" type="submit">
                  {sigGroupId ? "Update" : "Submit"}
                </Button>
              </div>
            </form>
            {/* Interactive Image Crop Modal */}
            <ImageCropModal
              open={cropModal.open}
              imageSrc={cropModal.src}
              backgroundColor="white"
              outputWidth={140}
              outputHeight={140}
              onCancel={() => setCropModal({ open: false, index: null, src: null })}
              onCrop={handleCropApply}
            />
          </div>
        </Box>
      )}
    </>
  );
};

export default SIGGroupForm;
